export class NotificationsStatusDTO {
  public unreadConversations: number[];
  public unreadNotifications: number[];
}
